// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container {
  width: calc(70vw - 250px);
  height: calc(100vh - 250px);
  overflow: scroll;
  border: 1px solid;
  z-index: 1;
}

canvas {
  display: block;
}

.controls {
  bottom: calc(100vh - 30px);
  right: calc(10vh + 1px);
  position: sticky;
  width: 100%;
  z-index: 1;
}

.controls2 {
  bottom: 10px;
  left: calc(10vh + 1px);
  position: sticky;
  width: 100%;
  z-index: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
